import mitt from 'mitt'
const dragEventBus = mitt()
export default dragEventBus
